import DialogSelect, {
  type DialogSelectProps,
} from "@/components/DialogSelect";
import { type HBModalProps } from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { getCollections } from "@/services";
import groupRecordsByPinyin from "@/utils/groupRecordsByPinyin";
import useReq from "@/utils/useReq";
import { useMemoizedFn } from "ahooks";
import { useMemo, useState } from "react";
import CollectionManagerDialog from ".";

export function useCollectionSelect(targetUserId, needPingyin = false) {
  const { data: collections, loading } = useReq(async () => {
    const { collections, err } = await getCollections(targetUserId);
    if (err) return [];

    if (needPingyin) {
      const groupResult = await groupRecordsByPinyin(
        collections,
        (item) => item.title
      );

      // 扁平化处理
      const list = [];

      groupResult.forEach((item) => {
        const pinyin = item[0];
        const items = item[1];
        // @ts-ignore
        items[0].pinyin = pinyin;
        list.push(
          ...items.map((item, index) => {
            return {
              key: item.collection_id,
              label: item.title,
              count: item.board_ids?.split(",")?.filter(Boolean)?.length || 0,
              pinyin: index === 0 ? pinyin : undefined,
            };
          })
        );
      });

      return list;
    }
    return collections.map((item) => {
      return {
        key: item.collection_id,
        label: item.title,
        count: item.board_ids?.split(",")?.length || 0,
      };
    });
  });

  const [searchKeyword, setSearchKeyword] = useState("");
  const onSearch = useMemoizedFn((keyword: string) => {
    setSearchKeyword(keyword);
  });

  const filteredCollections = useMemo(() => {
    if (!searchKeyword) return collections;
    return collections.filter((item) => item.label.includes(searchKeyword));
  }, [collections, searchKeyword]);

  return {
    collections: filteredCollections,
    onSearch,
    loading,
  };
}

function CollectionSelect({
  targetUserId,
  needPingyin = true,
  ...props
}: {
  targetUserId: string;
  needPingyin?: boolean;
} & DialogSelectProps &
  HBModalProps) {
  const { collections, onSearch, loading } = useCollectionSelect(
    targetUserId,
    needPingyin
  );

  return (
    <DialogSelect
      title="专辑"
      items={collections}
      onManage={() => {
        CollectionManagerDialog.open();
        props.onCancel?.();
      }}
      onSearch={onSearch}
      loading={loading}
      {...props}
    />
  );
}

const CollectionSelectModal = ModalWrap(CollectionSelect);

export default CollectionSelectModal;
